import React from 'react';
import SEO from './SEO';
import { PAGE_SEO } from '../utils/seoConfig';
import './Legal.css';

const TermsOfService = () => {
  const seo = PAGE_SEO['/terms'];
  return (
    <div className="legal-container">
      <SEO
        title={seo.title}
        description={seo.description}
        canonical="/terms"
        robots={seo.robots}
      />
      <h1>Terms of Service</h1>
      <p className="last-updated">Last Updated: {new Date().toLocaleDateString()}</p>

      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>By accessing and using FreshFitLab, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our service.</p>
      </section>

      <section>
        <h2>2. User Accounts</h2>
        <p>To use certain features of FreshFitLab, you must:</p>
        <ul>
          <li>Be at least 13 years old</li>
          <li>Maintain accurate account information</li>
          <li>Keep your login credentials secure</li>
          <li>Notify us of any unauthorized access</li>
        </ul>
      </section>

      <section>
        <h2>3. Acceptable Use</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Violate any laws or regulations</li>
          <li>Impersonate others</li>
          <li>Share harmful or malicious content</li>
          <li>Attempt to gain unauthorized access</li>
          <li>Use the service for commercial purposes without permission</li>
        </ul>
      </section>

      <section>
        <h2>4. Intellectual Property</h2>
        <p>All content on FreshFitLab, including but not limited to recipes, images, and text, is protected by copyright and other intellectual property rights.</p>
      </section>

      <section>
        <h2>5. AI Coach & Fitness Content Disclaimer</h2>
        <p>FreshFitLab provides an AI-powered fitness and nutrition coaching assistant, exercise databases, workout programs, and nutrition planning tools. These features are designed to help you track and organize your fitness goals. They are <strong>not intended to replace the advice, diagnosis, or treatment provided by a licensed physician, physical therapist, registered dietitian, or other qualified healthcare professional</strong>.</p>
        <ul>
          <li>Always consult your doctor or physical therapist before starting any new exercise program, especially if you have existing injuries, chronic conditions, or pain (including back pain, sciatica, or joint issues).</li>
          <li>The AI Coach does not diagnose medical conditions and is not a substitute for professional medical care.</li>
          <li>Exercise and nutrition recommendations are general in nature and may not be appropriate for your specific situation.</li>
          <li>You assume full responsibility for how you use the fitness and nutrition information provided by FreshFitLab.</li>
          <li>If you experience pain, dizziness, or discomfort during exercise, stop immediately and consult a healthcare professional.</li>
        </ul>
      </section>

      <section>
        <h2>6. Limitation of Liability</h2>
        <p>FreshFitLab is provided "as is" without warranties of any kind. We are not liable for any damages arising from your use of our service, including but not limited to injury, health complications, or adverse effects resulting from following exercise or nutrition recommendations.</p>
      </section>

      <section>
        <h2>7. Termination</h2>
        <p>We reserve the right to terminate or suspend access to our service immediately, without prior notice, for any violation of these Terms.</p>
      </section>

      <section>
        <h2>8. Changes to Terms</h2>
        <p>We may modify these terms at any time. Continued use of FreshFitLab after changes constitutes acceptance of the modified terms.</p>
      </section>

      <section>
        <h2>9. Contact Information</h2>
        <p>For questions about these Terms, please contact us at:</p>
        <p>Email: terms@freshfitlab.io</p>
      </section>
    </div>
  );
};

export default TermsOfService; 